import React from 'react';

const featuresBarItems = [
  { label: 'Luxury', sublabel: 'Golf Carts' },
  { label: 'Free', sublabel: 'Delivery' },
  { label: 'Affordable', sublabel: 'Family Fun' },
  { label: 'Dedicated', sublabel: 'Customer Care' },
];

const FeaturesBar: React.FC = () => {
  return (
    <section className="bg-white py-4 border-b">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center">
          {featuresBarItems.map((item, index) => (
            <div key={index}>
              <p className="text-2xl font-bold text-sky-600">{item.label}</p>
              <p className="text-sm text-gray-600">{item.sublabel}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesBar;